<template>
  <router-view />
  <AttachmentPreviewDialog />
</template>

<script>
import AttachmentPreviewDialog from '@/components/AttachmentPreviewDialog.vue'

export default {
  name: 'App',
  components: { AttachmentPreviewDialog }
}
</script>

<style>
* {
  box-sizing: border-box;
}

html,
body,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
}
</style>
